module.exports = __webpack_public_path__ + "img/des3.9503381a.jpg";